module.exports = __webpack_public_path__ + "img/thumbnail_BactrianCamel_m_normal.6e6f4d21.png";